<template>
    <b-container fluid >
        <b-row class="my-4 justify-content-center">

                <b-btn v-b-modal.newVersion variant="primary">Upload new version</b-btn>

        </b-row>
        <b-row v-if="versions">
            <b-col>
                <h1>Android application versions</h1>
                <b-table
                    striped
                    hover
                    :items="versions"
                    :fields="fields"
                    :per-page="perPage"
                    :current-page="currentPage">
                    <!--<template slot="index" slot-scope="data">
                        {{data.index + 1}}
                    </template>-->
                    <template slot="version_path" slot-scope="data">
                        <a :href="'http://adamapi.amplius.tech/uploads/android/' + data.item.version_path" target="_blank">{{data.item.version_path}}</a>
                    </template>
                </b-table>
                <b-pagination size="md" align="center" :total-rows="this.versions.length" v-model="currentPage" :per-page="perPage">
                </b-pagination>
            </b-col>
        </b-row>
        <b-modal centered
                 header-bg-variant="dark"
                 header-text-variant="white"
                 body-bg-variant="dark"
                 body-text-variant="white"
                 hide-footer
                 ref="newVersion"
                 id="newVersion"
                 title="Upload new version">
            <b-form v-on:submit.prevent="uploadVersion">
                <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Version:"
                        label-for="version">
                    <b-form-input id="version"
                                  type="number"
                                  size="sm"
                                  name="version"
                                  required>
                    </b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="4"
                        breakpoint="md"
                        label="Version file:"
                        label-for="version_upload">
                    <b-form-file id="version_upload"
                                 size="sm"
                                 name="version_upload"
                                 accept=".apk"
                                 v-model="file"
                                 required>
                    </b-form-file>
                </b-form-group>
                <b-btn type="submit" variant="primary" class="pull-right">Confirm</b-btn>
            </b-form>
        </b-modal>
    </b-container>
</template>

<script>
    export default {
        data() {
            return {
                versions: null,
                currentPage: 1,
                perPage: 10,
                fields: [
                    /*{
                        key: 'index',
                        label: 'No.',
                        sortable: true
                    },*/
                    {
                        key: 'version',
                        label: 'Version code',
                        sortable: true
                    },
                    {
                        key: 'version_path',
                        label: 'Path',
                        sortable: true
                    }
                ],
                file: null
            }
        },
        methods: {
            uploadVersion: function (e) {
                const formData = new FormData(e.target);
                adamApi.post(api.versions, formData).then( response => {
                        if (response.status === 201) {
                            this.$router.go();
                        }
                    }
                )
            }
        },
        created () {
            adamApi.get(api.versions)
                .then(response => {
                    if (response.status === 200) {
                        this.versions = response.data
                    }
                });
        }
    }
</script>
